import { SectionSubtitle, SectionTitle } from '@/sem/styles';
import type { SemPanelListModule } from '~/contracts/sem';
import useImageViews from '~/hooks/sem/useImageViews';
import Chevron from '~/icons/Chevron';
import { Link, ModuleInner } from './PopularSearches.styles';
import SemTrackWrapper from '../SemTrackWrapper';

type PopularSearchesImageProps = {
  className?: string;
  imageUrl: string;
  shouldShow?: boolean;
};

const PopularSearchesImage = ({
  className = '',
  imageUrl,
  shouldShow = false
}: PopularSearchesImageProps) => {
  return shouldShow ? (
    <picture>
      <source srcSet={imageUrl} media="(min-width: 1440px)" />
      <img
        src={imageUrl}
        alt="Searching for vehicles on Carvana"
        className={className}
      />
    </picture>
  ) : null;
};

type OwnProps = Omit<SemPanelListModule, '__typename'>;

export default function PopularSearches({
  id,
  imageViews,
  groups,
  image,
  subtitle,
  title
}: OwnProps) {
  const { imageUrl, shouldShowImageOnMobile, shouldShowImageOnDesktop } =
    useImageViews(imageViews, image);

  return id && groups ? (
    <SemTrackWrapper sectionName="Popular Searches">
      <ModuleInner>
        <div className="grid gap-24 m:order-2">
          <div className="grid gap-8">
            <SectionTitle>{title}</SectionTitle>
            <SectionSubtitle>{subtitle}</SectionSubtitle>
          </div>

          {groups.map((group, index) => {
            return group?.items ? (
              <div key={group.title ?? index} className="grid h-fit gap-24">
                {group.title ? (
                  <h3 className="tl-header-m">{group.title}</h3>
                ) : null}

                <div className="target rounded-md px-24">
                  {group.items.map(item =>
                    item?.slug ? (
                      <Link
                        key={item.slug}
                        href={item.slug}
                        data-analytics-id="Popular Searches - Link"
                        data-analytics-attributes={JSON.stringify({
                          title: item.title,
                          linkUrl: item.slug
                        })}
                      >
                        <p>{item.title}</p>

                        <Chevron className="stroke-blue-6" />
                      </Link>
                    ) : null
                  )}
                </div>
              </div>
            ) : null;
          })}
        </div>

        {imageUrl && (shouldShowImageOnDesktop || shouldShowImageOnMobile) ? (
          <div className="m:order-1">
            <PopularSearchesImage
              imageUrl={imageUrl}
              shouldShow={shouldShowImageOnDesktop}
              className="hidden m:block"
            />
            <PopularSearchesImage
              imageUrl={imageUrl}
              shouldShow={shouldShowImageOnMobile}
              className="m:hidden"
            />
          </div>
        ) : null}
      </ModuleInner>
    </SemTrackWrapper>
  ) : null;
}
